import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Simple fallback component in case app crashes
function Fallback() {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px', fontFamily: 'Arial' }}>
      <h2>Something went wrong</h2>
      <p>Please update your browser or try opening in Google Chrome.</p>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Try to render app safely
try {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error('App crashed:', error);
  root.render(<Fallback />);
}

// Report performance
reportWebVitals();
